import { Component, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { ReactivosService } from "app/main/wizard-cgo/services/reactivos.service";
import { IdiomasService } from 'app/main/wizard-cgo/services/idiomas.service';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import * as backInter from 'app/auth/auth-data.model';

@Component({
  selector: 'preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  animations : fuseAnimations
})
export class PreviewComponent implements OnInit {

  botones = [
    {
      blanca: 'blancas/surv_1.png',
      amarilla: 'surv_1.png',
      texto: 'Casi siempre es falso'
    },
    {
      blanca: 'blancas/surv_2.png',
      amarilla: 'surv_2.png',
      texto: 'Frecuentemente es falso'
    },
    {
      blanca: 'blancas/surv_3.png',
      amarilla: 'surv_3.png',
      texto: 'A veces es falso / A veces es verdad'
    },
    {
      blanca: 'blancas/surv_4.png',
      amarilla: 'surv_4.png',
      texto: 'Frecuentemente es verdad'
    },
    {
      blanca: 'blancas/surv_5.png',
      amarilla: 'surv_5.png',
      texto: 'Casi siempre es verdad'
    },
  ];
  cargando = true;
  guardados: any;
  idiomas: any[] = [];
  diseñoCaritas:number;

  idsPlantillas: any[] = [];
  reactivosPlantillas: any[] = [];

  reactivosMostrar: any[] = [];

  sinReactivos = false;
  preguntasTraduccionesAdicionalesFocus: backInter.respuestaTraduccionesPreguntasAdicionalesFocus;
  numeroTextosTraduccion: number[] = [];
  textosPreguntasFiltrados: any[] = [];

  constructor(
    private reactivosService: ReactivosService,
    private idiomasService: IdiomasService,
    private adicionalesService: AdicionalesService,
  ) { }

  // ngOnInit() {
  //   this.getReactivosGuardados();
  // }

  // getReactivosGuardados(){
  //   this.reactivosService.getGuardados(localStorage.getItem('encuestaID')).subscribe((respuesta:any) => {
  //     console.log(respuesta);
  //     this.guardados = respuesta;
  //   });
  // }
  ngOnInit() {
    this.getIdiomas();
    this.obtieneTraduccionesAdicionalesFocus();
  }

  getIdiomas(){
    this.idiomasService.getListaIdiomasFocus().subscribe( (data: any) => {
      console.log(data);
      this.idiomas = data.idiomas;
      this.getReactivosGuardados();
    });
  }

  getReactivosGuardados(){
    this.reactivosService.getGuardados(localStorage.getItem('encuestaID')).subscribe((respuesta:any) => {
      console.log(respuesta);
      this.guardados = respuesta;
      this.diseñoCaritas=respuesta.caritas;
      
      if(this.guardados.preguntas.length == 0){
        this.sinReactivos = true;
        this.cargando = false;
      }
      else{
        this.guardados.preguntas.forEach(pregunta => {
          let indice = this.idsPlantillas.findIndex(item => item.idPlantilla === pregunta.plantillaId);
          if(indice == -1){
            this.idsPlantillas.push(
              {
                idPlantilla: pregunta.plantillaId,
                obtenido: false
              }
            );
          }
        });
        console.log(this.idsPlantillas);
        this.idsPlantillas.forEach(idPlantilla => {
          this.getReactivosPlantilla(idPlantilla.idPlantilla);
        });
      }
    });
  }

  getReactivosPlantilla(plantillaId:string){
    let datos = {
      encuestaID: localStorage.getItem('encuestaID'),
      idPlantilla: plantillaId
    }
    this.reactivosService.getReactivos(datos).subscribe((respuesta:any) => {
      // console.log(respuesta);
      if(respuesta.success){
        this.reactivosPlantillas.push(respuesta);
      }
      console.log("reactivosplants:",this.reactivosPlantillas);

      let filtrarReactivos = true;
      this.idsPlantillas.forEach(plantilla => {
        if(plantilla.idPlantilla == plantillaId){
          plantilla.obtenido = true;
        }
        if(!plantilla.obtenido){
          filtrarReactivos = false;
        }
      });
      if(filtrarReactivos){
        console.log("a filtrar prro");
        this.filtraReactivosTraduccion();
      }
      else{
        console.log("aun no xd");
      }

    });
  }

  filtraReactivosTraduccion(){
    this.guardados.preguntas.forEach(pregunta => {
      let indicePlantilla = this.reactivosPlantillas.findIndex(item => item.idPlantilla === pregunta.plantillaId);
      if(indicePlantilla != -1){
        let indiceReactivo = this.reactivosPlantillas[indicePlantilla].reactivosNat.findIndex(item => item.pregunta === pregunta.pregunta);
        if(indiceReactivo != -1){
          let reactivoNativo = this.reactivosPlantillas[indicePlantilla].reactivosNat[indiceReactivo];
          let reactivosAdicionales: any[] = [];
          this.reactivosPlantillas[indicePlantilla].reactivosAdic.forEach(adicional => {
            if(adicional.id == reactivoNativo.id){
              reactivosAdicionales.push(adicional);
            }
          });
          let reactivoMostrar = {
            id: reactivoNativo.id,
          };
          reactivoMostrar[reactivoNativo.clave] = reactivoNativo.pregunta;
          reactivosAdicionales.forEach(adicional => {
            reactivoMostrar[adicional.clave] = adicional.pregunta;
          });
          this.idiomas.forEach(idioma => {
            if(!reactivoMostrar[idioma.clave]){
              reactivoMostrar[idioma.clave] = ' ';
            }
          });
          this.reactivosMostrar.push(reactivoMostrar);
        }
      }
    });
    console.log("reactivosmostrar:",this.reactivosMostrar);
    this.cargando = false;
    console.log(this.sinReactivos);

  }

  obtieneTraduccionesAdicionalesFocus(){
    let datos:any= {seccion: 2, empresaId:localStorage.getItem('companyID')};
    this.adicionalesService.getTraduccionesAdicionalFocus(datos).subscribe( (data:any) => {
      this.preguntasTraduccionesAdicionalesFocus=data;
      console.log(data)
      this.filtraTextosIdiomaPrincipalFocus();

});
}

filtraTextosIdiomaPrincipalFocus(){

  console.log(this.preguntasTraduccionesAdicionalesFocus);
  let numeroOpcionAdicional=0;
  this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.forEach( (adicional) => {
  let preguntas: any[]=[];
    adicional.preguntas.forEach( (textos) => {
      let numeroTextos=0;
      numeroTextos++;
      console.log(textos);
      if(textos.tipoRespuesta!=3){
        let  objetoTextoAdicional = {
          textoPregunta : textos.pregunta,
          tipoPregunta : textos.tipoAgregado,
          opcionesResp : textos.opciones,
          orden: textos.orden,
          tipoRespuesta: textos.tipoRespuesta,
          seccion: textos.seccion,
          requerido: textos.requerido,
          _id: textos._id,
          traduccion: textos.traduccion

        };
      preguntas.push(objetoTextoAdicional);
      numeroTextos+= textos.opciones.length;
      console.log(numeroTextos);
}else{
console.log("es de tipo 3 ");

}

      this.numeroTextosTraduccion.push(numeroTextos);

  });
    this.textosPreguntasFiltrados.push(
    {
      clave:   adicional.clave,
      idiomaId: adicional.idiomaId,
      preguntas: preguntas,
    });
      numeroOpcionAdicional++;
    console.log("textosPregFilt:",this.textosPreguntasFiltrados);
    this.cargando = false;
  });


}






}
